/*
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:03:24
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-11-06 16:02:33
 * @FilePath: \git\xht-web-business\src\config\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 环境配置
 * 根据不同的环境加载不同的配置
 */

// 获取环境变量
const env = process.env.NODE_ENV || 'development'

// 基础配置
const config = {
  // API基础地址（强制走相对路径，使用 devServer 代理转发）

  // 仅支持：本地开发 + 测试环境
  // 本地开发（dev server 代理转发）返回相对路径 ''
  // 测试环境通过 VUE_APP_API_BASE_URL 提供完整地址
  get apiBaseUrl () {
    const isLocal = (process.env.NODE_ENV === 'development') || /^(local|dev|development)$/i.test(process.env.VUE_APP_ENV || '')
    return isLocal ? '' : (process.env.VUE_APP_API_BASE_URL || '')
  },


  //测试环境
  // apiBaseUrl: process.env.VUE_APP_API_BASE_URL || '',
  //本地环境
  // apiBaseUrl: '',
  
  // 应用标题
  appTitle: process.env.VUE_APP_TITLE || '锡慧停业务平台',
  
  // 应用版本
  appVersion: process.env.VUE_APP_VERSION || '1.0.0',
  
  // 是否开启调试模式
  debug: process.env.VUE_APP_DEBUG === 'true',
  
  // 是否开启Mock数据
  mock: process.env.VUE_APP_MOCK === 'true',
  
  // 环境标识
  env: process.env.VUE_APP_ENV || env,
  
  // 微信公众号配置（对应XHT-TEST账号）
  wechat: {
    appId: process.env.VUE_APP_WECHAT_APP_ID || 'wx0a156f8bf6940a67', // XHT-TEST的appId
    // 微信授权回调域名（需要在微信公众平台配置）
    authRedirectDomain: process.env.VUE_APP_WECHAT_AUTH_REDIRECT_DOMAIN || ''
  }
}

// 开发环境特殊配置
if (env === 'development') {
  config.apiTimeout = 10000 // 10秒超时
  config.enableConsole = true
}

// 预发环境特殊配置
if (env === 'staging') {
  config.apiTimeout = 15000 // 15秒超时
  config.enableConsole = false
}

// 生产环境特殊配置
if (env === 'production') {
  config.apiTimeout = 20000 // 20秒超时
  config.enableConsole = false
}

// 打印当前环境配置（仅在开发环境）
if (config.debug) {
  console.log('当前环境配置:', config)
}

export default config
